import React from 'react';
import { Outlet } from 'react-router';
import { useSelector } from 'react-redux';
import { SYSTEM_ADMIN_PATH } from '../../../../constants';

const Users = React.lazy(() => import('./index'));
const UsersDetail = React.lazy(() => import('./User/Details'));

const GetUserDetails = ({ match }) => {
     const userDetail = useSelector((state) => state.admin.userDetails);

     return <span>{userDetail?.email || '...'}</span>;
};

const Routes = {
     path: SYSTEM_ADMIN_PATH.USERS,
     breadcrumb: 'Users',
     element: <Outlet />,
     children: [
          { index: true, element: <Users /> },
          {
               path: SYSTEM_ADMIN_PATH.USERS_DETAILS,
               breadcrumb: GetUserDetails,
               element: <UsersDetail />,
          },
     ],
};

export default Routes;
